import { Functie } from "@/entities/contactpersoon/constants.ts";
import { omitBy } from "@/shared/utils";

export const treinfuncties = [
    Functie.Hoofdconducteur,
    Functie.Machinist,
    Functie.WachtdientOpvangPersoneel,
    Functie.WachtdientOpvangReizigers,
] as const;
type TreinFunctie = (typeof treinfuncties)[number];

export const locatiefuncties = [Functie.MedewerkerOpLocatie, Functie.VrijwilligerOpStation] as const;
type LocatieFunctie = (typeof locatiefuncties)[number];

export const isTreinFunctie = (functie: Functie): functie is TreinFunctie => {
    return treinfuncties.includes(functie as TreinFunctie);
};
export const isLocatieFunctie = (functie: Functie): functie is LocatieFunctie => {
    return locatiefuncties.includes(functie as LocatieFunctie);
};

export const functieOptions = Object.entries(omitBy(Functie, (value) => value === "VOS")).map(([, v]) => ({
    label: v,
    value: v,
}));
